import type { ChatDoc } from '@odo/shared-ui';

export const QUICK_REPLY_TOKENS = [
    'doctor_last_name',
    'doctor_first_name',
    'patient_name',
    'patient_first_name'
] as const;

export type QuickReplyToken = (typeof QUICK_REPLY_TOKENS)[number];

export type QuickReplyTokenValues = Partial<Record<QuickReplyToken, string | null>>;

const TOKEN_PATTERN = new RegExp(`\\{(${QUICK_REPLY_TOKENS.join('|')})\\}`, 'g');

// A missing value becomes a [ ] blank so the unfilled-blank warning catches it on send.
function fillText(text: string, values: QuickReplyTokenValues): string {
    return text.replace(TOKEN_PATTERN, (_match, token: QuickReplyToken) => {
        const value = values[token]?.trim();
        return value || `[${token.replace(/_/g, ' ')}]`;
    });
}

export function fillQuickReplyTokens(node: ChatDoc, values: QuickReplyTokenValues): ChatDoc {
    if (node.type === 'text') return { ...node, text: fillText(node.text ?? '', values) };
    if (!node.content) return node;
    return { ...node, content: node.content.map((child) => fillQuickReplyTokens(child, values)) };
}
